<template>
	<section class="hero">
		<img class="hero-photo" src="/img/icon-team-picture.jpg" alt="" />
		<div class="hero-shade"></div>

		<header class="container header">
			<a href="#top" class="brand">
				<img src="/img/logo-mark-white.png" alt="" width="40" height="40" />
				<span class="brand-text">
					<b>Pablo Cerino</b>
					<span class="mono">Jiu-Jitsu · Uccle, Brussels</span>
				</span>
			</a>

			<nav class="nav" aria-label="Main">
				<a v-for="link in links" :key="link.href" :href="link.href">{{ link.label }}</a>
				<a class="btn btn-mat nav-cta" href="#contact">Contact us</a>
			</nav>

			<button
				type="button"
				class="menu-btn"
				aria-label="Open menu"
				:aria-expanded="menuOpen"
				aria-controls="mobile-menu"
				@click="menuOpen = true"
			>
				<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 7h16M4 12h16M4 17h16" /></svg>
			</button>
		</header>

		<div id="top" class="container hero-body">
			<span class="mono kicker">Brazilian Jiu-Jitsu · Uccle, Brussels</span>
			<h1 class="cap hero-title">Train<br />with us.</h1>
			<div class="hero-foot">
				<p>
					Gi, NoGi, women's only and kids classes, six days a week, with 4th degree black belt
					Pablo Cerino.
				</p>
				<div class="hero-actions">
					<a class="btn btn-mat" href="#schedule">See the timetable</a>
					<a class="btn btn-line" href="#contact">Get in touch</a>
				</div>
			</div>
		</div>

		<div v-if="menuOpen" id="mobile-menu" class="menu" role="dialog" aria-modal="true" aria-label="Menu">
			<div class="menu-top">
				<span class="brand">
					<img src="/img/logo-mark-white.png" alt="" width="34" height="34" />
					<b>Pablo Cerino</b>
				</span>
				<button type="button" class="menu-btn" aria-label="Close menu" @click="menuOpen = false">
					<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" /></svg>
				</button>
			</div>
			<nav class="menu-links" aria-label="Main">
				<a v-for="(link, i) in menuLinks" :key="link.href" :href="link.href" @click="menuOpen = false">
					<span class="cap">{{ link.label }}</span>
					<span class="mono">{{ String(i + 1).padStart(2, "0") }}</span>
				</a>
			</nav>
			<div class="menu-foot">
				<a class="btn btn-mat" :href="contact.phoneHref">Call {{ contact.phoneDisplay }}</a>
				<span class="mono">{{ contact.addressLine1 }}, {{ contact.addressLine2 }}</span>
			</div>
		</div>
	</section>
</template>

<script>
import { contact } from "../../data/site.js";

export default {
	data() {
		return {
			menuOpen: false,
			contact,
			links: [
				{ href: "#schedule", label: "Schedule" },
				{ href: "#plans", label: "Plans" },
				{ href: "#coach", label: "Coach" },
				{ href: "#faq", label: "FAQ" },
			],
			menuLinks: [
				{ href: "#schedule", label: "Timetable" },
				{ href: "#plans", label: "Plans" },
				{ href: "#coach", label: "Coach" },
				{ href: "#gym", label: "The gym" },
				{ href: "#faq", label: "FAQ" },
				{ href: "#contact", label: "Contact" },
			],
		};
	},
	watch: {
		menuOpen(open) {
			document.body.style.overflow = open ? "hidden" : "";
		},
	},
	mounted() {
		this.onKey = (event) => {
			if (event.key === "Escape") this.menuOpen = false;
		};
		window.addEventListener("keydown", this.onKey);
	},
	beforeUnmount() {
		window.removeEventListener("keydown", this.onKey);
		document.body.style.overflow = "";
	},
};
</script>

<style scoped>
.hero {
	position: relative;
	min-height: 720px;
	display: flex;
	flex-direction: column;
	overflow: hidden;
	background: var(--black);
	color: var(--white);
}

.hero-photo {
	position: absolute;
	inset: 0;
	width: 100%;
	height: 100%;
	object-fit: cover;
	object-position: 40% center;
	filter: grayscale(1);
}

.hero-shade {
	position: absolute;
	inset: 0;
	background: rgba(11, 11, 11, 0.7);
}

.header {
	position: relative;
	width: 100%;
	padding-top: 22px;
	padding-bottom: 22px;
	display: flex;
	justify-content: space-between;
	align-items: center;
	gap: 16px;
}

.brand {
	display: flex;
	align-items: center;
	gap: 12px;
	color: var(--white);
	text-decoration: none;
}

.brand:hover {
	color: var(--white);
}

.brand-text {
	display: flex;
	flex-direction: column;
	line-height: 1.1;
}

.brand-text b {
	font-size: 17px;
}

.brand-text .mono {
	font-size: 12px;
	color: #d6d6d6;
}

.nav {
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	gap: 24px;
}

.nav a:not(.btn) {
	color: var(--white);
	text-decoration: none;
	font-weight: 500;
	font-size: 15px;
}

.nav a:not(.btn):hover {
	color: var(--mat);
}

.nav-cta {
	min-height: 44px;
}

.menu-btn {
	display: none;
	width: 48px;
	height: 48px;
	place-items: center;
	padding: 0;
	border: 0;
	background: transparent;
	cursor: pointer;
}

.menu-btn svg {
	width: 24px;
	height: 24px;
	fill: none;
	stroke: var(--white);
	stroke-width: 2;
	stroke-linecap: round;
}

.hero-body {
	position: relative;
	flex-grow: 1;
	width: 100%;
	padding-top: 40px;
	padding-bottom: 64px;
	display: flex;
	flex-direction: column;
	justify-content: flex-end;
	gap: 28px;
}

.kicker {
	font-size: 13px;
	color: var(--mat);
}

.hero-title {
	font-size: clamp(88px, 12vw, 168px);
	line-height: 0.9;
}

.hero-foot {
	display: flex;
	flex-wrap: wrap;
	justify-content: space-between;
	align-items: flex-end;
	gap: 24px;
}

.hero-foot p {
	max-width: 460px;
	font-size: 18px;
	color: #e6e6e6;
}

.hero-actions {
	display: flex;
	flex-wrap: wrap;
	gap: 12px;
}

/* Full-screen phone menu */
.menu {
	position: fixed;
	inset: 0;
	z-index: 100;
	display: flex;
	flex-direction: column;
	background: var(--black);
	color: var(--white);
}

.menu-top {
	height: 64px;
	padding: 0 12px 0 20px;
	display: flex;
	justify-content: space-between;
	align-items: center;
	border-bottom: 1px solid #2a2a2a;
}

.menu .menu-btn {
	display: grid;
}

.menu-links {
	padding: 16px 20px;
	display: flex;
	flex-direction: column;
}

.menu-links a {
	min-height: 56px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	border-bottom: 1px solid #2a2a2a;
	color: var(--white);
	text-decoration: none;
}

.menu-links .cap {
	font-size: 32px;
}

.menu-links .mono {
	font-size: 14px;
	color: var(--mat);
}

.menu-foot {
	margin-top: auto;
	padding: 20px;
	display: flex;
	flex-direction: column;
	gap: 10px;
	text-align: center;
}

.menu-foot .mono {
	font-size: 12px;
	color: #a3a3a3;
}

@media (max-width: 860px) {
	.nav {
		display: none;
	}

	.menu-btn {
		display: grid;
	}

	.header {
		padding-top: 8px;
		padding-bottom: 8px;
	}
}

@media (max-width: 768px) {
	.hero {
		min-height: 640px;
	}

	.brand-text .mono {
		display: none;
	}

	.hero-body {
		padding-bottom: 32px;
		gap: 20px;
	}

	.kicker {
		font-size: 12px;
	}

	.hero-title {
		font-size: 96px;
		line-height: 0.88;
	}

	.hero-foot p {
		font-size: 16px;
	}

	.hero-actions {
		flex-direction: column;
		width: 100%;
	}

	.hero-actions .btn {
		width: 100%;
	}
}
</style>
